import "./TeamProfile.css";
import { PulseLoader } from "react-spinners";
import { useNavigate } from "react-router";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForm from "../../../../Components/Molecules/DeleteForm/DeleteForm";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { Height } from "@mui/icons-material";
import config from "../../../../config";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function TeamProfile({ loading, team, id, setGo }) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      {!loading ? (
        <div className="ProfileCont">
          <div className="greyBoxVer">
            <Typography
              sx={{
                color: "primary.main",
                fontSize: { xs: "28px", md: "35px" },
                fontWeight: "500",
                marginBottom: "10px",
              }}
            >
              {team?.name} Team
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              Welcome to your dedicated space for managing and accessing all the
              details of {team?.name} team in the{" "}
              <strong>
                {config.APP_NAME == "Code Reg"
                  ? "Code Challenge Competition"
                  : config.APP_NAME == "WeDo Reg"
                  ? "WeDo Challenge Competition"
                  : "International Robot Challenge Competition"}
              </strong>
              . Here, you can easily view and update team information. Keep
              everything organized and focus on achieving your best performance!
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "16px", md: "20px" },
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              Need Assistance?
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              For technical issues or questions about your team’s details,
              contact us at{" "}
              {config.APP_NAME == "Code Reg" ? (
                <a
                  href="mailto:support@codechallenge-championship.org"
                  style={{ textDecoration: "underline" }}
                >
                  support@codechallenge-championship.org
                </a>
              ) : config.APP_NAME == "WeDo Reg" ? (
                <a
                  href="mailto:support@wedochallenge.org"
                  style={{ textDecoration: "underline" }}
                >
                  support@wedochallenge.org
                </a>
              ) : (
                <a
                  href="mailto:Internationalrobotchallenge1@gmail.com"
                  style={{ textDecoration: "underline" }}
                >
                  Internationalrobotchallenge1@gmail.com
                </a>
              )}
              .
            </Typography>
          </div>

          <div className="greyBoxVer">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "22px" },
                  fontWeight: "600",
                }}
              >
                Team Details:
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PrimaryButton
                  classBtn={"center"}
                  btnType={"submit"}
                  text={"Edit Team Details"}
                  // loading={Edit ? editLoading : addLoading}
                  click={() => {
                    navigate(`/teams/edit/${id}/details`);
                  }}
                  style={{
                    textTransform: "capitalize",
                    minWidth: "170px",
                    borderRadius: "5px",
                    color: config.SECONDARY_COLOR,
                    backgroundColor: config.PRIMARY_COLOR,
                    marginRight: "5px",
                  }}
                />
                <DeleteForm
                  setGo={setGo}
                  id={team?.id}
                  title={`Are you sure to delete ${team?.name} ?`}
                  height={"40px"}
                  padding={"0 20px"}
                  text={"Delete Team"}
                />
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Team Name:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {team?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Coach:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {team?.coach?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Category:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {team?.category?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Age Group:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {team?.ageGroup?.name}
              </Typography>
            </Typography>
            {config.APP_NAME == "Code Reg" ? (
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Participate in:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {team?.onlineParticipant && team?.offlineParticipant
                    ? "Both Competitions (online & offline)"
                    : team?.onlineParticipant
                    ? "Online Competition"
                    : team?.offlineParticipant
                    ? "Offline Competition"
                    : ""}
                </Typography>
              </Typography>
            ) : (
              ""
            )}
          </div>
          <div className="greyBoxVer">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "22px" },
                  fontWeight: "600",
                }}
              >
                Team Members:
              </Typography>
              <PrimaryButton
                classBtn={"center"}
                btnType={"submit"}
                text={"Add/Delete Team Members"}
                // loading={Edit ? editLoading : addLoading}
                click={() => {
                  navigate(`/teams/edit/${id}/member`);
                }}
                style={{
                  textTransform: "capitalize",
                  minWidth: "260px",
                  // width: "100%",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                }}
              />
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "10px",
              }}
            >
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Name
                    </StyledTableCell>
                    {/* <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member National Id
                    </StyledTableCell> */}
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Birthday
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Age
                    </StyledTableCell>
                    <StyledTableCell align="right" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {team?.members?.map((member) => (
                    <StyledTableRow key={member.name}>
                      <StyledTableCell align="center">
                        {member.name}
                      </StyledTableCell>
                      {/* <StyledTableCell align="center">
                        {member?.nationalId ?? "-"}
                      </StyledTableCell> */}
                      <StyledTableCell align="center">
                        {member?.birthday?.split("T")?.at(0)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {member?.age} years
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {/* <EditIcon
                          sx={{
                            color: "#01579b",
                            cursor: "pointer",
                            margin: "0 0 0 5px",
                          }}
                          onClick={() =>
                            navigate(`/members/edit/${member?.id}`)
                          }
                        /> */}
                        <PrimaryButton
                          classBtn={"center"}
                          text={"Edit member"}
                          click={() => navigate(`/members/edit/${member?.id}`)}
                          style={{
                            textTransform: "capitalize",
                            borderRadius: "5px",
                            color: config.SECONDARY_COLOR,
                            backgroundColor: config.PRIMARY_COLOR,
                            height: "30px",
                            padding: "0 10px",
                            minWidth: "auto",
                            textWrap: "noWrap",
                          }}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      ) : (
        <div className="loadingBox">
          <PulseLoader color={config.PRIMARY_COLOR} />
        </div>
      )}
    </div>
  );
}

export default TeamProfile;
